import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import Loader from "../../../core/common/selfLoder";
import { employee_id } from "../../../environment";
import ReactImageMagnify from "react-image-magnify";

const Profile = () => {
  const route = all_routes;

  const {
    data: profileResponse,
    error: profileResponseError,
    loading: profileResponseLoading,
  } = useApi(`/api/get-employee-details/${employee_id}`, {
    method: "GET",
    autoCall: true,
  });

  const InfoItem = ({ label, value }) => (
    <dl className="mb-0">
      <dt className="small text-muted">{label}</dt>
      <dd className="mb-0">{value || "N/A"}</dd>
    </dl>
  );

  return (
    <>
      <Loader loading={profileResponseLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Profile </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/employee-dashboard">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Pages</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Profile{" "}
                  </li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="card">
            <div className="card-body mx-1 md:mx-4 ">
              {/* Header Section */}
              <div
                className="text-center mb-4"
                style={{ maxWidth: "200px", margin: "0 auto" }}
              >
                <ReactImageMagnify
                  {...{
                    smallImage: {
                      alt: "Employee Avatar",
                      isFluidWidth: true,
                      src:
                        (profileResponse &&
                          profileResponse.data &&
                          profileResponse.data[0] &&
                          profileResponse.data[0].photo) ||
                        "/assets/img/logo/profilepic.jpg",
                      width: 80, // smaller width
                      height: 80, // smaller height
                    },
                    largeImage: {
                      src:
                        (profileResponse &&
                          profileResponse.data &&
                          profileResponse.data[0] &&
                          profileResponse.data[0].photo) ||
                        "/assets/img/logo/profilepic.jpg",
                      width: 800,
                      height: 800,
                    },
                    enlargedImagePosition: "beside",
                    enlargedImageContainerDimensions: {
                      width: "300%",
                      height: "200%",
                    },
                  }}
                  style={{ display: "inline-block" }}
                />

                <h5 className="mt-2 mb-0">
                  {(profileResponse &&
                    profileResponse.data &&
                    profileResponse.data[0] &&
                    profileResponse.data[0].employee_name) ||
                    "N/A"}
                </h5>
                <small className="text-muted">
                  {(profileResponse &&
                    profileResponse.data &&
                    profileResponse.data[0] &&
                    profileResponse.data[0].employee_id) ||
                    "N/A"}
                </small>
              </div>

              {/* Basic Info */}
              <div className="mb-4">
                <h6 className="border-bottom pb-2 mb-3">Basic Information</h6>
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3">
                  <InfoItem
                    label="Department"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].department
                    }
                  />
                  <InfoItem
                    label="Sub-Department"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].sub_department
                    }
                  />
                  <InfoItem
                    label="Gender"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].gender
                    }
                  />
                  <InfoItem
                    label="Date of Birth"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].date_of_birth
                    }
                  />
                </div>
              </div>

              {/* Job Info */}
              <div className="mb-4">
                <h6 className="border-bottom pb-2 mb-3">Job Information</h6>
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3">
                  <InfoItem
                    label="Band"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].band
                    }
                  />
                  <InfoItem
                    label="Blood Group"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].blood_group
                    }
                  />
                  <InfoItem
                    label="Cost Center Code"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].cost_center_code
                    }
                  />
                  <InfoItem
                    label="Cost Center Name"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].cost_center_name
                    }
                  />
                </div>
              </div>

              {/* Manager Info */}
              <div className="mb-4">
                <h6 className="border-bottom pb-2 mb-3">Reporting Managers</h6>
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3">
                  <InfoItem
                    label="Primary Manager"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].primary_manager
                    }
                  />
                  <InfoItem
                    label="Secondary Manager"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].secondary_manager
                    }
                  />
                  <InfoItem
                    label="Extension Number"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].extension_number
                    }
                  />
                </div>
              </div>

              {/* Contact Info */}
              <div className="mb-4">
                <h6 className="border-bottom pb-2 mb-3">Contact Information</h6>
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3">
                  <InfoItem
                    label="Email"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].email_id
                    }
                  />
                  <InfoItem
                    label="Contact Number"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].contact_number
                    }
                  />
                  <InfoItem
                    label="Alternate Contact"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].alternate_contact_number
                    }
                  />
                  <InfoItem
                    label="Office Location"
                    value={
                      profileResponse &&
                      profileResponse.data &&
                      profileResponse.data[0] &&
                      profileResponse.data[0].work_location
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default Profile;
